import './icon-button.scss'
import { Icon as IconOCC } from '@vista-digital/occ-ui'
import type { FC, MouseEventHandler } from 'react'

export interface IconButtonProps {
    label?: string
    iconName: string
    iconSize?: number
    href?: string
    className?: string
    onButtonClick?: MouseEventHandler<HTMLButtonElement>
}

/**
 * Component to render anchor or button with an icon.
 * @param {string} href will make automatically make it return a tag if not null
 */

export const IconButton: FC<IconButtonProps> = props => {
    const { iconName, label, onButtonClick, href, className = 'icon-button', iconSize } = props
    const Icon = () => <IconOCC name={iconName} size={iconSize} />

    if (href) {
        return (
            // eslint-disable-next-line react/forbid-elements -- ok
            <a href={href} className={className}>
                {label}
                <span>
                    <Icon />
                </span>
            </a>
        )
    }

    return (
        <button className={className} onClick={onButtonClick}>
            {label}
            <Icon />
        </button>
    )
}
